import { ThirdPartyRefundProvider } from "@redotech/redo-model/third-party-refunds/provider";
import { zExt } from "@redotech/rpc/ext";
import { z } from "zod/v4";

export const setThirdPartyRefundProvider = {
  input: z.object({
    draftReturnId: zExt.objectId(),
    thirdPartyRefundProvider: z.enum(ThirdPartyRefundProvider).nullish(),
  }),
  output: z.object({
    thirdPartyRefundProvider: z.enum(ThirdPartyRefundProvider).nullish(),
  }),
};
